// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"73":"0f4ae6ff97bc765c271b","149":"01be911921a8050cdd99","488":"b12bf8426938cb772868","653":"48f504485bf78c1a5503","707":"76fc9476d279ab14d0cb","794":"6cec8edec6d17e3a5982","919":"6b5674d43c3b3dff7163","940":"52bddeb81b97fb740056"}[chunkId] + ".js";
};